import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/finance/finance-report/";

export function getFinanceDashboard(fiscalYear = 0, fiscalPeriod = 0) {
  return http.get(
    apiEndpoint + "finance-dashboard/" + fiscalYear + "/" + fiscalPeriod
  );
}

export function getProfitLossSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "profit-loss-summary/" + fiscalYearID);
}

export function getTurnoverAPARRatioSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "turnover-apar-ratio-summary/" + fiscalYearID);
}

export function getWorkingCapitalSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "working-capital-summary/" + fiscalYearID);
}

export function getTopRevenuesSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-revenues-summary/" + fiscalPeriodID);
}

export function getTopExpensesSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-expenses-summary/" + fiscalPeriodID);
}

export function getBalanceSheetReport(
  fiscalYearID = 0,
  fiscalYear = 0,
  fiscalPeriod = 0
) {
  return http.get(
    apiEndpoint +
      "balance-sheet-report/" +
      fiscalYearID +
      "/" +
      fiscalYear +
      "/" +
      fiscalPeriod
  );
}

export function getProfitLossReport(
  fiscalYearID = 0,
  fiscalYear = 0,
  fiscalPeriod = 0
) {
  return http.get(
    apiEndpoint +
      "profit-loss-report/" +
      fiscalYearID +
      "/" +
      fiscalYear +
      "/" +
      fiscalPeriod
  );
}

export function getCashFlowReport(
  fiscalYearID = 0,
  fiscalYear = 0,
  fiscalPeriod = 0
) {
  return http.get(
    apiEndpoint +
      "cash-flow-report/" +
      fiscalYearID +
      "/" +
      fiscalYear +
      "/" +
      fiscalPeriod
  );
}

export function getAccountsReceivableAgingReport() {
  return http.get(apiEndpoint + "accounts-receivable-aging-report");
}

export function getAccountsPayableAgingReport() {
  return http.get(apiEndpoint + "accounts-payable-aging-report");
}

export function getOperationCashFlow() {
  return http.get(apiEndpoint + "operation-cash-flow");
}

export function getGlAccountBalance(
  fiscalYearID = 0,
  fiscalYear = 0,
  fiscalPeriod = 0,
  glAccountID = 0
) {
  return http.get(
    apiEndpoint +
      "gl-account-balance/" +
      fiscalYearID +
      "/" +
      fiscalYear +
      "/" +
      fiscalPeriod +
      "/" +
      glAccountID
  );
}

export function getSalesTaxReport(
  fiscalYearID = 0,
  fiscalYear = 0,
  fiscalPeriod = 0
) {
  return http.get(
    apiEndpoint +
      "sales-tax-report/" +
      fiscalYearID +
      "/" +
      fiscalYear +
      "/" +
      fiscalPeriod
  );
}
